import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function taskServiceOfferingsReducer(state = initialstate.taskServiceOfferings, action) {
	switch (action.type) {
		case types.GET_TASK_SERVICE_OFFERINGS:
			return action.response || state;
		case types.RESET_TASK_ATTRIBUTES:
			return initialstate.serviceOfferings;
		default:
			return state;
	}
}
